import { CONSTANTS } from "@/core/utils/func/constants";

export type ShareablePreviewMode = "debug" | "user";

/**
 * Source unique : le mode debug n'est autorisé que si
 * `VITE_NODE_ENV=development`. Tout autre env (production, uat, …) force
 * le mode user — y compris si un appelant passe `mode="debug"`.
 */
export function isShareablePreviewDebugAllowed(): boolean {
  return CONSTANTS.NODE_ENV === "development";
}

export function resolveShareablePreviewMode(
  requested?: ShareablePreviewMode
): ShareablePreviewMode {
  if (!isShareablePreviewDebugAllowed()) {
    return "user";
  }
  return requested ?? "debug";
}
